// utilities
import tools from './utilities/tools';
import animationPreferences from './utilities/animation-preferences';
import scrollEffects from './utilities/scroll-effects';
import customEvents from './utilities/custom-events';

// layouts
import header from './layouts/header';

// sections
import hero from './sections/hero';
import gallery from './sections/gallery';

const App = {
    init: () => {
        // custom events
        customEvents.initResizeEnd();
        customEvents.initResizeStart();
        customEvents.initScrollEvents();

        // utilities
        animationPreferences.init();
        tools.init();

        // layouts
        header.init();

        // sections
        hero.init();        
    },
    load: () => {
        // utilities
        scrollEffects.init();

        // sections
        gallery.init();
        hero.load();
    }
}

document.addEventListener('DOMContentLoaded', App.init);
window.addEventListener('load', App.load);